import building from "../assets/building.jpg";
import hall from "../assets/event-hall.jpg";
import mainPool from "../assets/main-pool.jpg";
import buildingView from "../assets/building-view.jpg";
import dinningArea from "../assets/dinning-area.jpg";
import staff from "../assets/staff.jpg";
import bedroom from "../assets/bedroom.jpg";
import dinning2 from "../assets/dinning-area3.jpg";
import eventHall from "../assets/banquet_event.jpg";
import barImg from "../assets/party-area.jpg";
import poolImg from "../assets/main-pool.jpg";
import gym from "../assets/zym.jpg";
import sittingArea from "../assets/sitting-area2.jpg";
import entrance from "../assets/mainEntrance.jpg";
import kichen from "../assets/serving-area.jpg";
import parking from "../assets/parking.jpg";
import washroom from "../assets/washroom.jpg"
import wifi from "../assets/wifi.png";
import petsBan from "../assets/banPets.png";
import carRental from "../assets/carRental.png";
import customerSupport from "../assets/customerSupport.png";


export const LOGO = "https://res.cloudinary.com/simplotel/image/upload/x_0,y_0,w_130,h_130,r_0,c_crop,q_80,dpr_1,f_auto,fl_progressive/tgi-hotels-and-resorts---3624/Image_-1_rtvdbd";

export const CAROUSEL_DATA = {
    name:"TGI Hotel",
    about: "Hotel TGI Grand Fortuna is a beacon of modernity and luxury in the heart of Hosur, ensuring guests a delightful stay. Its elegant ambience, plush interiors and strategic location near Hosur Railway Station and popular areas like Koramangala and HSR make it the perfect choice for travellers seeking comfortable accommodation. Its position on the outskirts of Bengaluru also offers convenient access to the city for both business and leisure, ensuring a seamless blend of work and relaxation."
}

export const CAROUSEL_IMG = [
    building, hall, mainPool, buildingView, dinningArea, staff
];

export const SERVICES = [
    {
        id: 1,
        title: "Discover Comfort at the Heart of Hosur!", 
        img: building, 
        description: "In a commercial area with shops and businesses, this stylish hotel is 3 km from Murugan Temple and 4 km from Hosur train station. Featuring floor-to-ceiling windows, relax rooms with contemporary vibe offer free Wi-Fi, flat screen TV's and mini fridges, as well as tea and coffeemakers. Suites provide separate living areas, room service is available. Breakfast and parking are included. Amenities consist of 2 restaurants, 1 with patio dining, along with an outdoor pool and a spa."
    },
    { 
        id: 2, 
        title: "Stylish Accommodations in Hosur", 
        img: bedroom, 
        description: "Our Hotel in Hosur offers three impeccable lodging options namely, Superior Rooms, Grand Suites and Fortuna Suites. These accommodations exude an ambience of serenity and sophistication while providing a range of exceptional amenities such as air-conditioning, minibar, television and free Wi-Fi. Each room and suite boasts a distinctive style and decor, enhancing your experience at the hotel." },
    { id: 3, 
        title: "Diverse Dining Options", 
        img: dinning2, 
        description: "Indulge in a variety of multi-cuisine specialties at our exclusive Flavours Restaurant, which has earned a reputation as a favorite among our guests for its skillful use of spices and flavourful dishes. Additionally, our hotel features The Flames Bar, renowned for its selection of imported beers and a wide range of alcoholic beverages, offering the perfect setting to unwind after a busy day in Hosur." },
    {
        id: 4, 
        title: "Event Spaces for Every Occasion", 
        img: eventHall, 
        description: "We offer pristine venues suitable for a wide range of events including meetings, seminars, weddings, gatherings and parties. Our three spacious banquet halls include Crown Conference Hall, Grand Ball Room and  Pavillion Board Room that can accommodate 20 to 350 guests at a time. These banquet spaces are elegantly appointed and come equipped with state-of-the-art amenities and services." },
    { 
        id: 5, 
        title: "Excellent Facilities", 
        img: sittingArea, 
        description: "As a Hosur hotel, we prioritise meeting all your needs under our roof, allowing you to unwind after a busy day in the city. We provide a range of facilities like a gym, a swimming pool, an in-house bar and ample parking spaces. These combined with our exceptional hospitality and dedicated staff help us make your Hosur stay as successful and enjoyable as possible." },
]

export const FACILITIES_DATA = [
    {
        id:7,
        img: dinningArea,
        title: "In-House Bar"
    },
    {
        id:8,
        img: hall,
        title: "In-House Meeting Hall"
    },
    {
        id:9,
        img: poolImg,
        title: "In-House Pool"
    },
    {
        id:10,
        img: gym,
        title: "Gym"
    },
    {
        id:11,
        img: barImg,
        title: "In-House Bar"
    },
    {
        id:12,
        img: parking,
        title: "Spacious Parking Facility"
    },
]

export const OTHER_FAC = [
    {
        id:13,
        img:carRental,
        title: "Car Rental"
    },
    {
        id:14,
        img:customerSupport,
        title: "Customer Support"
    },
    {
        id:15,
        img:wifi,
        title: "WiFi"
    },
    {
        id:16,
        img:petsBan,
        title: "No pets"
    }
]

export const CONTACT_INFO = {
    name:"TGI Apple Inn, Jaipur",
    address: "D.No.3/24, Seetharam Nagar, Krishnagiri Main Road, Hosur, Tamil Nadu - 635109",
    email:"appleinn@tgihotels.com",
    phone1:"+91 04344 667 600",
    phone2:"180 0258 3100",
}

export const GALLERY_DATA = [
    {
        id : 17,
        title:"Building View",
        img: building,
    },
    {
        id : 18,
        title:"Event Hall",
        img: hall,
    },
    {
        id : 19,
        title:"Pool",
        img: mainPool,
    },
    {
        id : 20,
        title:"Dinning Area",
        img: dinningArea,
    },
    {
        id : 28,
        title:"Kichen",
        img: kichen,
    },
    {
        id : 21,
        title:"Entrance",
        img: entrance,
    },
    {
        id : 22,
        title:"Bedroom",
        img: bedroom,
    },
    {
        id : 24,
        title:"Sitting Area",
        img: sittingArea,
    },
    {
        id : 25,
        title:"Gym",
        img: gym,
    },
    {
        id : 26,
        title:"Parking",
        img: parking,
    },
    {
        id : 27,
        title:"Washroom",
        img: washroom,
    },
    // building, hall, mainPool, buildingView, dinningArea, infoImage, bedroom, rooftopDinning, dinning2, eventHall, barImg, poolImg, gym, parking, 
]